@for (emailWrapper of emailArray; track $index; let index = $index) {
  <div>
    <div class="row">
      <div class="form-group col pt-1 pb-1">
        <conn-email-input
          (modelChanged)="setEmailBuilderValue(index, $event)"
          [inputModel]="emailWrapper.inputText"
          [required]="true"
          [submitted]="submitted"
        >
        </conn-email-input>
      </div>
      <div class="col-1 buttonPadding">
        @if (index !== 0 || emailArray.length > 1) {
          <i
            (click)="removeEmail(index)"
            class="trashBtn fa fa-trash fa-lg"
            id="removeEmailButton"
          ></i>
        }
      </div>
    </div>
    @if (index + 1 === emailArray.length) {
      <div class="col-12">
        <div class="row">
          <div class="col-12 text-start">
            <div
              (click)="addEmail()"
              class="btn btn-link btn-link-font-size"
              id="addEmailButton"
            >
              + Add more
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
